// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "nemo-header-" + (chunkId === 74 ? "lazy-search" : chunkId) + "-" + {"74":"9e54b40a058fecc0fe97","536":"23dca77c789d8ac0f56d"}[chunkId] + ".js";
};